import React from 'react';
import moment from 'moment';
import {
    faExternalLinkAlt,
} from '@fortawesome/free-solid-svg-icons';
import userIcon from '../../assets/images/iconos/icono-017.png';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';

  const calculardiasentrega = (date1, date2) => {

    let fFormat01 = moment(date1).format('DD-MM-YYYY');
    let fFormat02 = moment(date2).format('DD-MM-YYYY');

    let startDate = moment(fFormat01, 'DD-MM-YYYY');
    let endDate = moment(fFormat02, 'DD-MM-YYYY');
    let dayDiff = endDate.diff(startDate, 'days');
    return dayDiff;
  }

  const customStyles = {
    rows: {
      style: {
        minHeight: '72px', // override the row height
      }
    },
    headCells: {
      style: {
        paddingLeft: '8px', // override the cell padding for head cells
        paddingRight: '8px',
      },
    },
    cells: {
      style: {
        paddingLeft: '8px', // override the cell padding for data cells
        paddingRight: '8px',
      },
    },
  };

  const colummnsPaquete = (prefijo, detalledespacho) => {
    return [
       {
        name: 'Guia',
        selector: row => `${prefijo}-${row.guia_paquete}`,
        sortable: true,
        wrap: true,
       },
      {
        name: 'Fecha de entrega',
        selector: row => moment(row.fecha_entrega).format('DD/MM/YYYY'),
        sortable: true,
        wrap: true,
      },
      {
        name: 'Hora de entrega',
        selector: 'hora_entrega',
        sortable: true,
        wrap: true,
      },
      {
        name: 'Entregado por',
        selector: row => row.depacho_usuario.nombre_usuario,
        sortable: true,
        wrap: true,
        cell: row => (
          <div className="d-flex">
              <div className="small-profile-dbx" style={{ backgroundImage: row.depacho_usuario.imagen_perfil ? `url(https://awsjupiter21.s3.amazonaws.com/DIBOXAPP/perfiles_app/${row.depacho_usuario.imagen_perfil})` : userIcon }}>
              </div>
              <div className="delivery-name">{row.depacho_usuario.nombre_usuario}</div>
          </div>
        )
      },
      {
        name: 'Días en transito',
        selector: row => calculardiasentrega(row.despacho_guia.createdAt, row.fecha_entrega),
        sortable: true,
        wrap: true,
        center: true,
      },
      {
        name: 'Resumen',
        right: true,
        cell: row => (
            <button onClick={() => detalledespacho(row)} className="btnx btnx-warn icon-table m-1">
                 <FontAwesomeIcon icon={faExternalLinkAlt} />
            </button>
        )
      },
    ]
  }


  const table = {
    colummnsPaquete,
    customStyles,
  }

  export default table;